// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"hT-z","inlineTitle":"iT-z","sponsoredAdsWrapper":"jT-z","marketplaceRecosWrapper":"kT-z"};